import React from 'react';
import Icon from './icons';
import { ConfirmBox } from './EventsList';
import { useSch } from './context';
import { daySegments } from '../../../schedule/model';

function Day24({ rule }) {
  const { col } = useSch();
  const c = col(rule.show);
  return (
    <div className="sch6-day24" aria-hidden="true">
      {daySegments(rule.from, rule.to).map(([a, b]) => (
        <i key={a} style={{ background: c, insetInlineStart: `${(a / 1440) * 100}%`, width: `${((b - a) / 1440) * 100}%` }} />
      ))}
    </div>
  );
}

/** «الجدول المعتاد»: the weekly rules as plain sentences, or the week view. */
export default function RulesList({ list, view, onView, week, confirmDel, onAdd, onToggle, onEdit, onDelete, onNo, onYes }) {
  const { t, f, showName, col, whereText } = useSch();
  return (
    <section className="sch6-list" aria-labelledby="sch6-ruh">
      <div className="sch6-sechead">
        <h2 id="sch6-ruh">{t('sch6.usual')}</h2>
        <div className="sch6-seg" role="group" aria-label={t('sch6.view_aria')}>
          <button type="button" aria-pressed={view === 'list'} onClick={() => onView('list')}>{t('sch6.view_list')}</button>
          <button type="button" aria-pressed={view === 'week'} onClick={() => onView('week')}>{t('sch6.view_week')}</button>
        </div>
      </div>
      {view === 'week' ? week : (
        <>
          {!list.length && (
            <div className="sch6-empty-row">{t('sch6.rules_empty')}
              <button type="button" className="sch6-btn" onClick={onAdd}><Icon name="plus" />{t('sch6.add_short')}</button>
            </div>
          )}
          {list.map((r) => {
            const name = showName(r.show);
            return (
              <React.Fragment key={r.id}>
                <div className={`sch6-card sch6-item${r.on ? '' : ' sch6-off'}`}>
                  <span className="sch6-sw" style={{ background: col(r.show) }} />
                  <div className="sch6-t">
                    <b>{name}</b>{!r.on && <>{' '}<span className="sch6-badge sch6-mute">{t('sch6.paused')}</span></>}
                    <div className="sch6-s"><strong>{f.daysTxt(r.days)}</strong>{` · ${f.rangeTxt(r.from, r.to)} · ${whereText(r)}`}</div>
                    <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', alignItems: 'center' }}>
                      <div className="sch6-days" aria-hidden="true" title={t('sch6.days_title')}>
                        {[0, 1, 2, 3, 4, 5, 6].map((i) => <span key={i} className={r.days.includes(i) ? 'sch6-on' : ''}>{f.dayLetter(i)}</span>)}
                      </div>
                      <Day24 rule={r} />
                    </div>
                  </div>
                  <div className="sch6-ctrl">
                    <button type="button" className="sch6-switch" role="switch" aria-checked={r.on} onClick={() => onToggle(r)} aria-label={t(r.on ? 'sch6.toggle_off_aria' : 'sch6.toggle_on_aria', { name })} />
                    <button type="button" className="sch6-icon-btn" onClick={() => onEdit(r)} aria-label={t('sch6.edit_aria', { name })}><Icon name="edit" /></button>
                    <button type="button" className="sch6-icon-btn" onClick={() => onDelete(r)} aria-label={t('sch6.delete_aria', { name })}><Icon name="trash" /></button>
                  </div>
                </div>
                {confirmDel && confirmDel.id === r.id && <ConfirmBox onNo={onNo} onYes={onYes} />}
              </React.Fragment>
            );
          })}
          <p className="sch6-note"><Icon name="clock" /><span>{t('sch6.tz_note')}</span></p>
        </>
      )}
    </section>
  );
}
